import { render, staticRenderFns } from "./CertificadoDetalle.vue?vue&type=template&id=96312b6e&"
import script from "./CertificadoDetalle.vue?vue&type=script&lang=js&"
export * from "./CertificadoDetalle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports